
import { Component, Ref, Vue } from "vue-property-decorator";
import Tinymce from "@/components/Tinymce/index.vue";
import api from "@/api";
import { CmsContentStatus, CreateOrEditCmsContentDto } from "@/api/appService";
import { ElForm } from "element-ui/types/form";
import Base64 from "@/utils/Base64";

@Component({
  components: { Tinymce }
})
export default class EditCmsContent extends Vue {
  @Ref() dataForm!: ElForm;
  id: number = 0;
  show = false;
  categories: any[] = [];
  defaultData: CreateOrEditCmsContentDto = {
    categoryId: undefined,
    title: undefined,
    titleImageUrl: undefined,
    content: undefined,
    id: 0
  };

  form: CreateOrEditCmsContentDto | undefined = { ...this.defaultData };

  async created() {
    console.log(this.$route.params);
    if (this.$route.params && this.$route.params.id){
      this.id = parseInt(this.$route.params.id);
    }
    this.fetchCategories();

    await api.cmsContent.getForEdit({ id: this.id }).then(res => {
      console.log("cms getForEdit");
      if (this.id) {
        this.form = {...res.data};
      }
    });
  }

  fetchCategories(){
    api.cmsCategory.getAll({maxResultCount:65535}).then(res=>{
      this.categories = res.items!.filter(s=>!s.copyFromId);
    })
  }

  private cancel() {
    this.$router.back();
  }

  private async saveAsDraft() {
    this.save(CmsContentStatus.Draft);
  }

  private async saveAndPublish() {
    this.save(CmsContentStatus.Published);
  }

  private async save(cmsContentStatus: CmsContentStatus) {
    console.log(this.form);
    this.dataForm.validate(async (valid: boolean) => {
      if (valid) {
        this.form!.status = cmsContentStatus;
        if (this.form!.id) {
          await api.cmsContent.update({ body: this.form });
        } else {
          await api.cmsContent.create({ body: this.form });
        }
        this.show = false;
        this.$message.info("更新成功");
        this.$message({
          type: "success",
          message: "成功"
        });
        setTimeout(() => {
          this.$router.push({ name: "cmsContentList" });
        }, 200);
      }
    });
  }

  uploadData: {
    authorization: string;
    file: string;
    policy: string;
  } = {
    authorization: "",
    file: "",
    policy: ""
  };

  // 头像上传
  private async beforeAvatarUpload(file: any) {
    console.log(file);
    const isJPG = file.type === "image/jpeg";
    const isLt2M = file.size / 1024 / 1024 < 3;
    if (!isLt2M) {
      this.$message.error("上传头像图片大小不能超过 3MB!");
      return false;
    }

    // @ts-ignore
    var date = new Date().toGMTString();
    var opts = {
      "save-key": "/{year}/{mon}/{day}/upload_{random32}{.suffix}",
      bucket: "hudongdaxue",
      expiration: Math.round(new Date().getTime() / 1000) + 3600,
      date: date
    };

    var policy = Base64.encode(JSON.stringify(opts));
    var data = ["POST", "/" + "hudongdaxue", date, policy].join("&");

    await api.client.getSignature({ data: data }).then(res => {
      console.log(res);
      this.uploadData = {
        file: file.name,
        authorization: `UPYUN hudongdaxue:${res.signature}`,
        policy: policy
      };
    });

    return isLt2M;
  }

  private async handleAvatarSuccess(res: any, file: any) {
    console.log(res);
    if (res.message === "ok") {
      this.form!.titleImageUrl = `https://img2.gongyila.com${res.url}!w500`;
    }
  }

  cmsContentRule = {
    categoryId: [
      {
        required: true,
        message: "必填",
        trigger: "blur"
      }
    ],
    title: [
      {
        required: true,
        message: "必填",
        trigger: "blur"
      }
    ],
    titleImageUrl: [
      {
        required: true,
        message: "必填",
        trigger: "blur"
      }
    ],
    content: [
      {
        required: true,
        message: "必填",
        trigger: "blur"
      }
    ]
  };
}
